"use client"

import { useEffect } from "react"
import { isChunkLoadError, recoverFromChunkLoadError } from "@/lib/utils/chunk-error"

/**
 * Catches stale-bundle chunk failures that happen outside React rendering -
 * lazy `import()` calls in event handlers, prefetches, script loads - and
 * reloads once so the tab picks up the current build.
 *
 * Failures raised during render/navigation are handled by `app/error.tsx`.
 */
export function ChunkErrorRecovery() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (isChunkLoadError(event.error) || isChunkLoadError(event.message)) {
        recoverFromChunkLoadError()
      }
    }

    const handleRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadError(event.reason)) {
        recoverFromChunkLoadError()
      }
    }

    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleRejection)

    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleRejection)
    }
  }, [])

  return null
}
